import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../lib/utils";

/** Centered loading state for a page or card body. */
export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center justify-center py-16", className)}>
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
